import { useTranslation } from '@ecomm/i18n'
import { Modal } from '@ecomm/shared-components/lib/Modal'
import { useState } from 'react'

export function SkipThisStepModal() {
  const [isOpen, setIsOpen] = useState(false)
  const handleOpenToggle = () => {
    setIsOpen(!isOpen)
  }
  const { t } = useTranslation('maps')

  return (
    <>
      <button
        className="border-none bg-transparent cursor-pointer p-0 outline-none text-lg underline hover:no-underline"
        onClick={handleOpenToggle}
      >
        {t('choose-monitoring.skip-step')}
      </button>
      <Modal
        isOpen={isOpen}
        onRequestClose={() => {
          setIsOpen(false)
        }}
        aria={{ labelledby: 'skipThisStepTitle' }}
      >
        <div className="p-8">
          <h3
            className="mb-3 mt-0 text-3xl	font-medium md:text-4xl"
            id="skipThisStepTitle"
          >
            {t('choose-monitoring.are-you-sure')}
          </h3>
          <p className="m-0 mb-4 text-base md:text-lg">
            {t('choose-monitoring.modal-legend')}
          </p>
          <div className="mt-8 flex flex-col items-center justify-around text-center md:flex-row">
            <button
              className="btn btn-solid-primary max-w-xs w-full md:w-auto "
              data-testid="InformationModalCloseButton"
              onClick={() => {
                setIsOpen(false)
              }}
            >
              {t('choose-monitoring.choose-a-plan')}
            </button>
            <a
              href="/cart"
              rel="noreferrer"
              target="_self"
              className="w-full md:w-auto btn btn-outlined btn-outlined-tertiary !text-neutral-black mt-2 text-lg hover:underline md:mt-0"
            >
              {t('choose-monitoring.skip-anyway')}
            </a>
          </div>
        </div>
      </Modal>
    </>
  )
}
